<template>
    <div>
        <div >
            <Header />
            <div id="error" class="container">
                <h3>This page is undergoing maintenance and is unavailable. We're sorry for the inconvenience.</h3>
                <h3>If you are experiencing a technical issue, please contact Technical Support at:</h3>
                <span v-html="$store.getters.errorMessage"></span>
                <p>Click <router-link to="/">here</router-link> to return to Application. </p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    import Header from "./shared/Header";
    export default {
        name: "Error",
        components: {
            Header
        },
        data() {
            return {
            };
        },
        methods: {
            ...mapActions("oidcStore", [
                "authenticateOidc"
            ]),
        }
    };
</script>